interface PullQuoteProps {
  quote: string;
  attribution?: string;
}

export default function PullQuote({ quote, attribution }: PullQuoteProps) {
  return (
    <blockquote className="border-l-4 border-[#C8102E] bg-[#F5F4F0] px-6 py-4 my-7">
      <p className="font-['Playfair_Display',Georgia,serif] font-semibold italic text-[21px] leading-[1.45] text-[#0D0D0D]">
        "{quote}"
      </p>
      {attribution && (
        <cite className="block font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#6B6B6B] mt-2 not-italic">
          — {attribution}
        </cite>
      )}
    </blockquote>
  );
}
